import { Lookup } from "src/app/shared/models/lookup";
import { AuditableEntity } from "../../auditable-entity";
import { IndicatorGroupType, SppIndicatorGroup } from "./spp-indicator-group";

export interface SppIndicatorSearchItem extends AuditableEntity {
  id: string;
  name: string;
  groupName: string;
  indicatorTarget: number;
  targetComparison: TargetComparisonType;
  isActive: boolean;
  dataLoaded: boolean;
}

export interface SppIndicatorRequest {
  id?: string;
  sppIndicatorGroupId?: string;
  targetComparison?: TargetComparisonType;
  indicatorTarget?: number;
  indicatorName: string;
  indicatorDescription: string;
  graphTitle: string;
  sortOrderInGroupId: number;
  chartMinValue: number;
  chartMaxValue: number;
  chartValueType: number;
  color: string;
  stateLineColor: string;
  targetLineColor: string;
  dataLoadedDate?: string;
  isActive: boolean;
  chartTypeId?: number;
  noDataText: string;
  isUseLatestTargetValue: boolean;
}

export interface SppIndicator extends AuditableEntity {
  id: string;
  indicatorName: string;
  indicatorDescription: string;
  sppIndicatorGroupId: string;
  sppIndicatorGroup?: SppIndicatorGroup;
  sppIndicatorTypeId: string;
  sppIndicatorType?: SppIndicatorType;
  targetComparison: TargetComparisonType;
  indicatorTarget: number;
  graphTitle: string;
  sortOrderInGroupId: number;
  chartMinValue: number;
  chartMaxValue: number;
  chartValueType: number;
  color: string;
  stateLineColor: string;
  targetLineColor: string;
  dataLoadedDate: Date;
  isActive: boolean;
  schoolYear: string;
  chartTypeId?: ChartType;
  noDataText: string;
  isUseLatestTargetValue: boolean;
}

export interface SppIndicatorType extends AuditableEntity {
  number: number;
  label: string;
  IndicatorGroup: IndicatorGroupType;
}

export interface SppIndicatorReportRequest {
  administrativeUnitId?: string;
  sppIndicatorId?: string;
  schoolYear: string;
}

export enum TargetComparisonType {
  LessThanOrEqual = 1,
  Equal = 2,
  GreaterThanOrEqual = 4,
  LessThan = 5,
  GreaterThan = 6,
}

export enum ChartType {
  NA = 0,
  Bar = 1,
  Pie = 2,
  Trend = 3,
}
